import React from 'react'

import arrow from './../../UI/general/arrow_btn.svg'

import { videoData } from '../../data/video.data'

interface Props {
  isVideoOpened: boolean,
  completeCar: string,
  handleIsVideoOpened: (payload: boolean) => void
}

interface State {
  currentVideoSelected: string
}

class VideoMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentVideoSelected: ''
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.isVideoOpened !== this.props.isVideoOpened && this.props.isVideoOpened){
      var currentVideoData: any = videoData()
      this.setState({
        currentVideoSelected: currentVideoData[this.props.completeCar]
      })
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isVideoOpened ? 'video-main-container-mobile fade-in':'video-main-container-mobile fade-out'}>
          <div className='video-top-bar-mobile'>

          </div>
          <div className='video-frame-container-mobile'>
            <iframe 
              src={this.props.isVideoOpened && this.state.currentVideoSelected !== '' ? this.state.currentVideoSelected +"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0":""} 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"   
              className={this.props.isVideoOpened ? 'fade-in':'fade-out'} 
              title='video'
            />
          </div>
          <div className='video-frame-container-bottom-mobile'>
            <div className='close-video-btn-mobile'>
              <div className='close-btn-image'>
                <img src={arrow} alt=''/>
              </div>
              <div className='close-btn-text-mobile' onClick={() => {this.props.handleIsVideoOpened(false)}}>
                REGRESAR
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default VideoMobile